import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import * as XLSX from 'xlsx';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import qs from 'qs';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

  import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";


const API_BASE_URL = "https://api.drivergems.com";

function generateSignature(method, urlPath, timestamp) {
  const secretKey = "jnpkXDAM1GBvyDxYITtukz43zekx6UXgpipODwW9KY5";
  const message = `${method}${urlPath}${timestamp}`;
  return CryptoJS.HmacSHA256(message, secretKey).toString(CryptoJS.enc.Hex);
}

const formatDateTime = (dateString) => {
  if (!dateString || dateString === "N/A") return "N/A";
  const date = new Date(dateString);
  return date.toLocaleString("en-IN", {
    day: "numeric",
    month: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: true,
    timeZone: "Asia/Kolkata"
  });
};
const DormantUsersTable = ({startdate,enddate, searchQuery, onExportRef, onRefreshRef, selectedRoId,onExportpdfRef}) => {
  const [users, setUsers] = useState([]);
  const [filtered, setFiltered] = useState([]);
  
const [sortStates, setSortStates] = useState({
  lastTransaction: "asc",
  dormantDays: "asc",
  remainingPoints: "asc",
});


const sortData = (key) => {
  let direction = "asc";
  if (sortStates[key] === "asc") {
    direction = "desc";
  }

  const sorted = [...filtered].sort((a, b) => {
    const valA = a[key];
    const valB = b[key];

    if (key === "lastTransaction") {
      return direction === "asc"
        ? new Date(valA) - new Date(valB)
        : new Date(valB) - new Date(valA);
    } else {
      return direction === "asc" ? valA - valB : valB - valA;
    }
  });

  setFiltered(sorted);
  // ✅ update only clicked column direction, preserve others
  setSortStates((prev) => ({ ...prev, [key]: direction }));
};

  const fetchDormantUsers = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) return;

      const method = "GET";
      const timestamp = Math.floor(Date.now() / 1000).toString();

      // ✅ Date ranges
      const today = new Date();
      const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);
      const from90Days = new Date(lastMonthEnd);
      from90Days.setDate(from90Days.getDate() - 90);

      const startISO = from90Days.toISOString();
      const endISO = today.toISOString();

      // ✅ Fetch all users
      const usersApi = "/v1/user/consumerdetails/referredbyme";
      const sigUsers = generateSignature(method, usersApi, timestamp);
      const usersQuery = qs.stringify({ start_date: startISO, end_date: endISO,ro_id:selectedRoId });

      const usersResp = await axios.get(`${API_BASE_URL}${usersApi}?${usersQuery}`, {
        headers: { Authorization: `Bearer ${token}`, "X-Signature": sigUsers, "X-Timestamp": timestamp }
      });
      const allUsers = usersResp.data.users || [];

      // ✅ Fetch transactions
      const transactionsApi = "/v2/user/transactions/fuel/range";
      const sigTxn = generateSignature("GET", transactionsApi, timestamp);
      const txnQuery = qs.stringify({ start_date: startISO, end_date: endISO ,ro_id:selectedRoId});

      const txnResp = await axios.get(`${API_BASE_URL}${transactionsApi}?${txnQuery}`, {
        headers: { Authorization: `Bearer ${token}`, "X-Signature": sigTxn, "X-Timestamp": timestamp }
      });

      const transactions = Array.isArray(txnResp.data)
        ? txnResp.data
        : Array.isArray(txnResp.data.transactions)
        ? txnResp.data.transactions
        : [];

      // ✅ Fetch reward points (Single API Call)
      const pointsApi = "/v1/user/consumerrewardpoints";
      const sigPoints = generateSignature(method, pointsApi, timestamp);
      const pointsQuery = qs.stringify({ start_date: startISO, end_date: endISO ,ro_id:selectedRoId});

      const pointsResp = await axios.get(`${API_BASE_URL}${pointsApi}?${pointsQuery}`, {
        headers: { Authorization: `Bearer ${token}`, "X-Signature": sigPoints, "X-Timestamp": timestamp },
      });

    const rewardMap = new Map();

if (Array.isArray(pointsResp.data?.users)) {
  pointsResp.data.users.forEach(p => {
    rewardMap.set(p.phone, {
      points: parseInt(p.total_reward_points) || 0,
      lastTxn: p.last_transaction_date ? new Date(p.last_transaction_date) : null
    });
  });
}

      // ✅ Build transaction maps
      const lastTxnBeforeMap = new Map();
      const latestTxnMap = new Map();
      const hasRecentTxnSet = new Set();

      transactions.forEach(txn => {
        const phone = txn.phone;
        const txnDate = new Date(txn.date);

        // Track latest txn
        if (!latestTxnMap.has(phone) || txnDate > latestTxnMap.get(phone)) {
          latestTxnMap.set(phone, txnDate);
        }

        // Track last txn before lastMonthEnd
        if (txnDate <= lastMonthEnd) {
          if (!lastTxnBeforeMap.has(phone) || txnDate > lastTxnBeforeMap.get(phone)) {
            lastTxnBeforeMap.set(phone, txnDate);
          }
        }

        // Mark activation if txn after lastMonthEnd
        if (txnDate > lastMonthEnd) {
          hasRecentTxnSet.add(phone);
        }
      });

  const userData = allUsers
  .filter(u => {
    const lastTxnDate = lastTxnBeforeMap.get(u.phone);
    if (!lastTxnDate) return false;
    const diffDays = Math.floor((lastMonthEnd - lastTxnDate) / (1000 * 60 * 60 * 24));
    return diffDays > 30;
  })
  .map(u => {
    const rewardInfo = rewardMap.get(u.phone) || {};
    const lastTxnFromPoints = rewardInfo.lastTxn;

    const lastBefore = lastTxnBeforeMap.get(u.phone);
    const latestTxn = lastTxnFromPoints || latestTxnMap.get(u.phone); // ✅ Prefer consumerrewardpoints API date
    const lastTxnStr = latestTxn ? latestTxn.toISOString() : "N/A";

    const dormantDays = lastBefore
      ? Math.floor((lastMonthEnd - lastBefore) / (1000 * 60 * 60 * 24))
      : 999;

    return {
      name: `${u.firstname || ""} ${u.lastname || ""}`.trim(),
      phone: u.phone || "",
      lastTransaction: lastTxnStr,
      dormantDays,
      remainingPoints: rewardInfo.points || 0,
      activated: hasRecentTxnSet.has(u.phone)
    };
  });

      setUsers(userData);
      setFiltered(userData);
    } catch (err) {
      console.error("Error fetching dormant users:", err);
      setUsers([]);
      setFiltered([]);
    }
  };
 useEffect(() => {
    const lower = (searchQuery || "").toLowerCase();
    setFiltered(users.filter(u =>
      u.name.toLowerCase().includes(lower) || u.phone.includes(lower)
    ));
  }, [searchQuery, users]);

   useEffect(() => {
    if (onRefreshRef) onRefreshRef.current = fetchDormantUsers;
  },  [onRefreshRef, fetchDormantUsers, selectedRoId, startdate, enddate]);


    useEffect(() => {
    if (onExportRef) onExportRef.current = () => {
      const worksheet = XLSX.utils.json_to_sheet(filtered);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Dormant Users");
      XLSX.writeFile(workbook, "dormant_users.xlsx");
    };
  }, [filtered,onExportRef,selectedRoId]);


useEffect(() => {
  if (onExportpdfRef)
    onExportpdfRef.current = () => {

      if (!filtered || filtered.length === 0) {
        alert("No data to export!");
        return;
      }

      // Convert JSON rows into PDF table format
      const headers = Object.keys(filtered[0]);
      const body = filtered.map(item => Object.values(item));

      // Create PDF
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "pt",
        format: "a4"
      });

      // Title
      doc.setFontSize(14);
      doc.text("Dormant Users Report", 40, 40);

      // Generate table
      autoTable(doc, {
        startY: 60,
        head: [headers],
        body: body,
        styles: { fontSize: 10, cellPadding: 6 },
        headStyles: {
          fillColor: [240, 240, 240],
          textColor: 20,
          fontStyle: "bold"
        },
        margin: { left: 40, right: 20 },
        didDrawPage: (dataArg) => {
          // Add page number in footer
          const pageSize = doc.internal.pageSize;
          const pageHeight = pageSize.height || pageSize.getHeight();
          doc.setFontSize(9);
          doc.text(
            `Page ${dataArg.pageNumber}`,
            pageSize.width - 60,
            pageHeight - 10
          );
        }
      });

      // Save PDF
      doc.save("dormant_users.pdf");
    };
}, [filtered, onExportpdfRef,selectedRoId]);

 
  useEffect(() => { fetchDormantUsers(); }, [selectedRoId]);
  // ✅ Search
  useEffect(() => {
    const lower = (searchQuery || "").toLowerCase();
    setFiltered(users.filter(u => u.name.toLowerCase().includes(lower) || u.phone.includes(lower)));
  }, [searchQuery, users,selectedRoId]);

  useEffect(() => { fetchDormantUsers(); }, [selectedRoId]);

  // ✅ Export
  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filtered);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Dormant Users");
    XLSX.writeFile(workbook, "dormant_users.xlsx");
  };
const totalCount = filtered.length;
const activatedCount = filtered.filter(u => u.activated).length;

  return (
    <div>
     <div style={{ marginBottom: "10px", padding: "10px" }}>
      <div><strong>Total Dormant Users:</strong> {totalCount}</div>
      <div><strong>Activated Users:</strong> {activatedCount}</div>
      <div style={{ fontSize: "15px", color: "gray" }}>
        <strong>Note:</strong> Users are considered <em>dormant</em> if they had no transactions for over 30 days 
        before the last month end. Users who transacted after the last month end are shown as <em>activated</em>.
      </div>
    </div>
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
 <TableRow style={{background:"lightgrey"}}>
    <TableCell style={{border:"2px solid #a7a4a4"}}><strong>Name</strong></TableCell>
    <TableCell style={{border:"2px solid #a7a4a4"}}><strong>Phone</strong></TableCell>
    <TableCell style={{ cursor: "pointer",border:"2px solid #a7a4a4" }} onClick={() => sortData("lastTransaction")}>
  <strong>Last Transaction Date</strong>{" "}
  {sortStates.lastTransaction === "asc" ? "🔼" : sortStates.lastTransaction === "desc" ? "🔽" : ""}
</TableCell>

<TableCell style={{ cursor: "pointer",border:"2px solid #a7a4a4" }} onClick={() => sortData("dormantDays")}>
  <strong>Dormant Days (till Last Month End)</strong>{" "}
  {sortStates.dormantDays === "asc" ? "🔼" : sortStates.dormantDays === "desc" ? "🔽" : ""}
</TableCell>

<TableCell style={{ cursor: "pointer",border:"2px solid #a7a4a4" }} onClick={() => sortData("remainingPoints")}>
  <strong>Reward Points Balance</strong>{" "}
  {sortStates.remainingPoints === "asc" ? "🔼" : sortStates.remainingPoints === "desc" ? "🔽" : ""}
</TableCell>


    <TableCell style={{border:"2px solid #a7a4a4"}}><strong>Activated</strong></TableCell>
  </TableRow>
</TableHead>

        <TableBody>
          {filtered.length > 0 ? filtered.map((u, i) => (
            <TableRow key={i}>
              <TableCell>{u.name}</TableCell>
              <TableCell>{u.phone}</TableCell>
              <TableCell>{formatDateTime(u.lastTransaction)}</TableCell>
              <TableCell>{u.dormantDays}</TableCell>
              <TableCell>{u.remainingPoints}</TableCell>
              <TableCell>{u.activated ? <CheckCircleIcon color="success" /> : <CancelIcon color="error" />}</TableCell>
            </TableRow>
          )) : (
            <TableRow><TableCell colSpan={6} align="center">No dormant users found</TableCell></TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
    </div>
  );
};

export default DormantUsersTable;
